import ArrowP from './arrow.svg'
export default ArrowP
